import toast from "react-hot-toast";
import { apiEndPoints } from "../../ApiServices/config";
import { postApi } from "../../ApiServices/api";
function useLoadBalgokulPayment(){
    const devoteeData = JSON.parse(localStorage.getItem("devoteeData"));

    const onSubmit = async (data) => {
        const productData = [
          {
            total: data.amount,
            items: {
              _id: data.registeration_no,
              type: 8,
              name: "Balgokul Registeration Payment",
              description: data.description,
              email: data.email,
              no_students: data.no_students,
              quantity: 1,
              price: data.amount,
              date: new Date(),
            },
          },
        ];
    
        try {
          const response = await postApi(apiEndPoints.stripePayment, {
            productData: productData,
            customerData: devoteeData,
            bookingId: "",
          });
          if (response?.data?.status === 1) {
            localStorage.setItem("orderId", response.data.orderData._id);
            setTimeout(() => {
              window.location.href = response?.data?.url;
            }, 1000);
          } else {
            toast.error("Something went wrong");
          }
        } catch (error) {
          toast.error("Something went wrong");
          console.log(error);
        }
      };

    return {
        onSubmit
    };
}

export default useLoadBalgokulPayment;